export type ButtonSize =
  | 'small'
  | 'medium'
  | 'regular'
  | 'normal'
  | 'wide'
  | 'large'
  | 'extra-large'
  | 'double-extra-large'
  | 'extra-wide'
  | 'full-width'
  | 'auto';

export type ButtonType =
  | 'primary'
  | 'secondary'
  | 'ternary'
  | 'quaternary'
  | 'quinary'
  | 'link'
  | 'advisory'
  | 'transparent-dark';

export type ButtonRoleType = 'button' | 'link';

export type ElementType = 'button' | 'icon' | 'link' | 'submit';
